<template>
  <div class="tft">
    <Brackets></Brackets>
  </div>
</template>
<script>
import Brackets from "../../components/Brackets";
export default {
  components: {
    Brackets
  }
}
</script>
